"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFormListContainer = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const create_attribute_form_constants_1 = require("./create-attribute-form.constants");
const create_attribute_form_styles_1 = require("./create-attribute-form.styles");
const partials_1 = require("./partials");
const attribute_form_list_item_component_1 = require("./partials/attribute-form-list-item.component");
const value_form_list_1 = require("./value-form-list");
const utils_1 = require("../../../utils");
const localization_1 = require("../../../../localization");
const AttributeFormListContainer = ({ name, values, attributesOptionList = [], hideDescription, valueOptionListStrategyNodeId, selectedStrategyNodeId, isRemoveDisabled, allowCreation, isReadOnly, isValueListHeightDynamic, matchedValueNames, loadedValueItems, valuesLoading, valuesHasNextPage, valuesMoreItemsLoading, valueSectionLabels, onValuesLoadMore, onValueSearch, onRemove, getFieldValueByName, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    // Formik does not provide an error for the array itself if there are errors in the nested fields
    const isDuplicationError = (0, react_1.useMemo)(() => (0, utils_1.areDuplicatesExist)({ list: values, propName: 'name' }), [values]);
    return (react_1.default.createElement(create_attribute_form_styles_1.StyledFormSection, null, values === null || values === void 0 ? void 0 : values.map((item, index) => {
        const attributeLabel = getFieldValueByName(values, `${index}.${create_attribute_form_constants_1.AttributeFormFieldNames.Name}`);
        const isNewLabel = !!attributeLabel
            && attributesOptionList.findIndex(({ label }) => (0, utils_1.areEqualCaseInsensitive)(label, attributeLabel)) === -1;
        const shouldShowDivider = values.length > 1 && index < values.length - 1;
        const shouldConstrainValueListHeight = !isValueListHeightDynamic && values.length === 1;
        return (react_1.default.createElement(react_1.default.Fragment, { key: index }, react_1.default.createElement(attribute_form_list_item_component_1.AttributeFormListItem, { itemLabel: attributeLabel, name: `${name}.${index}`, descriptionFieldTitle: t({ key: 'ENTITY_GUIDELINES', values: { entity: t({ key: 'ATTRIBUTE' }) } }), isRemoveDisabled: isRemoveDisabled, hideDescription: hideDescription, isReadOnly: isReadOnly, isNestedListHeightDynamic: isValueListHeightDynamic, readonly: item.readonly, onRemoveClick: () => onRemove(index) }, attributeLabel && (react_1.default.createElement(partials_1.FormListManager, { name: `${name}.${index}.${create_attribute_form_constants_1.AttributeFormFieldNames.Values}`, component: value_form_list_1.ValueFormList, componentProps: {
                hideDescription,
                attributeLabel,
                isNewLabel,
                valueOptionListStrategyNodeId,
                selectedStrategyNodeId,
                allowCreation,
                isReadOnly,
                isHeaderSticky: isValueListHeightDynamic,
                matchedValueNames,
                loadedValueItems,
                valuesLoading,
                valuesHasNextPage,
                valuesMoreItemsLoading,
                sectionLabels: valueSectionLabels,
                onValuesLoadMore,
                onBackendSearch: onValueSearch,
                shouldConstrainListHeight: shouldConstrainValueListHeight,
            } }))), shouldShowDivider && react_1.default.createElement(material_1.Divider, { className: "attribute-form-item-divider" })));
    }), isDuplicationError && (react_1.default.createElement(ui_components_1.Typography, { color: "error", variant: "caption" }, t({ key: 'VALIDATION_MUST_BE_UNIQUE', values: { name: t({ key: 'ATTRIBUTE' }) } })))));
};
exports.AttributeFormListContainer = AttributeFormListContainer;
exports.default = exports.AttributeFormListContainer;
